import React, { useState, useEffect, useRef } from "react";

const AutoBotConfiguration = (props) => {
    const { skillBotConfiguration, updateskillBotConfiguration } = props;
    const [files, setFiles] = useState([]);
    const MAX_TOTAL_SIZE = 1024 * 1024 * 1024; // 1 GB
    const fileInputRef = useRef(null);


    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        updateskillBotConfiguration(name, type === "checkbox" ? checked : value);
    }

    const handleFileChange = (e) => {

        const selectedFiles = Array.from(e.target.files);

        // Only PDFs
        const pdfFiles = selectedFiles.filter(
            (file) =>
                file.type === "application/pdf" ||
                file.name.toLowerCase().endsWith(".pdf")
        );

        if (pdfFiles.length === 0) {
            alert("Please select PDF files only.");
            return;
        }

        // Calculate total size
        const totalSize = pdfFiles.reduce(
            (sum, file) => sum + file.size,
            0
        );

        // Validate 1 GB limit
        if (totalSize > MAX_TOTAL_SIZE) {

            const sizeInGB = (
                totalSize /
                (1024 * 1024 * 1024)
            ).toFixed(2);

            alert(
                `Total selected files size is ${sizeInGB} GB. Maximum allowed is 1 GB.`
            );

            e.target.value = "";

            return;
        }

        setFiles(pdfFiles);
        updateskillBotConfiguration(
            "Files", pdfFiles
        )
    };

    return (
        <>
            <div className="form-group"><b>Please select the configuration for the bot type you want to create</b></div>
            <div className="form-group checkbox-row">
                <div className="form-config-box-check">
                    <input
                        type="checkbox"
                        name="SimpleChatBot"
                        checked={skillBotConfiguration.SimpleChatBot}
                        onChange={(e) => {
                            handleChange(e);
                            updateskillBotConfiguration("PDFWithImages", false);
                            updateskillBotConfiguration("PDFWithText", false);
                            updateskillBotConfiguration("Files", []);
                            setFiles([]);
                            if (fileInputRef.current)
                                fileInputRef.current.value = null;
                        }}
                    />
                    <div> Simple Chat bot </div>
                </div>
            </div>
            <div className="form-group checkbox-row">
                <div className="form-config-box-check">
                    <input
                        type="checkbox"
                        name="PDFWithImages"
                        checked={skillBotConfiguration.PDFWithImages}
                        onChange={(e) => {
                            handleChange(e);
                            updateskillBotConfiguration("SimpleChatBot", false);
                            updateskillBotConfiguration("PDFWithText", false);
                        }}
                    />
                    <div> PDF With Images </div>
                </div>
                <div className="form-config-box-check">
                    <input
                        type="checkbox"
                        name="PDFWithText"
                        checked={skillBotConfiguration.PDFWithText}
                        onChange={(e) => {
                            handleChange(e);
                            updateskillBotConfiguration("SimpleChatBot", false);
                            updateskillBotConfiguration("PDFWithImages", false);
                        }}
                    />
                    <div> PDF With Text </div>
                </div>
            </div>
            {(skillBotConfiguration.PDFWithImages || skillBotConfiguration.PDFWithText) && (
                <div>
                    <div className="form-group"><b>Knowledge Source</b></div>
                    <br />
                    <div className="form-group checkbox-row">
                        <div className="form-config-box-check">

                            <input type="file" ref={fileInputRef}
                                multiple accept=".pdf"
                                onChange={handleFileChange}
                            />
                        </div>
                    </div>
                </div>)}
            <div className="form-group margin-model">
                <div className="form-config-box">
                    <div className="input-wrapper">
                        <label>Purpose</label>
                        <textarea
                            className="prompt-text"
                            placeholder="Enter Purpose"
                            value={skillBotConfiguration.Purpose || ""}
                            onChange={(e) =>
                                updateskillBotConfiguration(
                                    "Purpose", e.target.value
                                )
                            }
                            rows={4}
                        />

                    </div>
                </div>
                <div className="form-config-box ">
                    <div className="input-wrapper">
                        <label>Tone</label>
                        <textarea
                            className="prompt-text"
                            placeholder="Enter Tone"
                            value={skillBotConfiguration.Tone || ""}
                            onChange={(e) =>
                                updateskillBotConfiguration(
                                    "Tone", e.target.value
                                )
                            }
                            rows={4}
                        />
                    </div>
                </div>
            </div>
            <div className="form-group margin-model">
                <div className="form-config-box">
                    <div className="input-wrapper">
                        <label>Persona</label>
                        <textarea
                            className="prompt-text"
                            placeholder="Enter Persona"
                            value={skillBotConfiguration.Persona || ""}
                            onChange={(e) =>
                                updateskillBotConfiguration(
                                    "Persona", e.target.value
                                )
                            }

                            rows={4}
                        />

                    </div>
                </div>
                <div className="form-config-box">
                    <div className="input-wrapper">

                    </div>
                </div>
            </div>
        </>
    );
};

export default AutoBotConfiguration;
